import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {FormFieldComponent} from './form-field/form-field.component';

@NgModule({
    declarations: [FormFieldComponent],
    imports: [CommonModule, FormsModule],
    exports: [FormFieldComponent],
})
export class SharedModule {}
